import { render, staticRenderFns } from "./Attachments.vue?vue&type=template&id=5f616d84&scoped=true&lang=pug"
import script from "./Attachments.vue?vue&type=script&lang=ts"
export * from "./Attachments.vue?vue&type=script&lang=ts"
import style0 from "./Attachments.vue?vue&type=style&index=0&id=5f616d84&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f616d84",
  null
  
)

export default component.exports